import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import { BASE_URL_SCAB, URL_PORTAL_SERVICOS_API } from "../util/constants";


@Injectable()
export class CredenciaisService {

  constructor(
    private http: HttpClient
  ) { }

  getCredenciaBySolicitacao(idSolicitacao: number): Observable<any> {
    return this.http.get(URL_PORTAL_SERVICOS_API
      + '/credencialUsuario/buscarCredencialPorSolicitacao?idSolicitacao=' + idSolicitacao);
  }

  gerarCredencialHmg(credencial: any) {
    return this.http.post(URL_PORTAL_SERVICOS_API
      + '/credencialUsuario/gerarCredencialUsuarioHomologacao', credencial);
  }

  gerarCredencialProd(credencial: any) {
    return this.http.post(URL_PORTAL_SERVICOS_API
      + '/credencialUsuario/gerarCredencialUsuarioProducao', credencial);
  }

  getCredenciaByService(app: any): Observable<any> {
    return this.http.post(BASE_URL_SCAB+'/api/solicitacao/pesquisarSolicitacaoExterna',
        {
          "ano": app.solicitacao.nuAno,
          "numero": app.solicitacao.nuSolicitacao
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/credenciais.service.ts